import type { Direction } from '../sim/direction';
import { PlayerSprite, type SpriteLayer } from './playerSprite';

/**
 * Arena enemies use the body animation machinery without the interactive and
 * overhead-label surfaces that player and NPC sprites need.
 *
 * Horde sprites are pooled by the renderer (PRD #826). A dense Arena wave spawns
 * and kills continuously - the benchmark measured roughly sixty corpse
 * conversions a second - so building one of these per enemy and destroying it
 * when its corpse timed out was a steady stream of display-object construction
 * for a population whose size barely changes. {@link recycle} re-dresses a spent
 * sprite for the next enemy instead.
 */
export class HordeSprite extends PlayerSprite {
  constructor(layers: SpriteLayer[], initialFacing: Direction) {
    super(layers, initialFacing, undefined, undefined, undefined, { interactive: false });
  }

  /**
   * Re-dress this spent sprite for a newly spawned enemy, clearing the held death
   * pose, the corpse fade, and every other trace of the previous occupant.
   */
  recycle(layers: SpriteLayer[], initialFacing: Direction): void {
    this.resetForReuse(layers, initialFacing);
  }
}
